import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';

import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { NextDataQuality } from 'src/app/models/dataQuality.model';
import { CustomerService } from 'src/app/services/customer.service';
import { BuildingService } from 'src/app/services/building.service';
import { PoleService } from 'src/app/services/pole.service';
import { DtService } from 'src/app/services/dt.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-review',
  templateUrl: './review.component.html',
  styleUrls: ['./review.component.scss'],
})
export class ReviewComponent implements OnInit {
  @Input() assetType: string;
  @Input() assetId: number;
  @Input() fieldAuditDisabled: boolean = false;
  @Output() closeModal = new EventEmitter<NextDataQuality | null>();

  constructor(
    private customerService: CustomerService,
    private buildingService: BuildingService,
    private poleService: PoleService,
    private dtService: DtService,
    private toastr: ToastrService,
    private router: Router,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit(): void {}

  submitReview() {
    switch (this.assetType) {
      case 'Customer': {
        this.analyticsService.logCustomEvent('CUSTOMER DETAILS: Review', {
          customer_id: this.assetId,
        });

        var customerObj = {
          customerId: this.assetId
        };

        this.customerService.reviewCustomer(customerObj).subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.toastr.success('Successfully reviewed the customer.');
              this.closeModal.emit(responseData.data);
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured.');
          },
        });
        break;
      }
      case 'Building': {
        this.analyticsService.logCustomEvent('BUILDINGS DETAILS: Review', {
          customer_id: this.assetId,
        });

        var buildingObj = {
          buildingId: this.assetId
        };
        this.buildingService.reviewBuilding(buildingObj).subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.toastr.success('Successfully reviewed the building.');
              this.closeModal.emit(responseData.data);
              this.handleReturn();
            } else {
              this.toastr.warning(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured.');
          },
        });
        break;
      }
      case 'Pole': {
        this.analyticsService.logCustomEvent('POLE DETAILS: Review', {
          pole_id: this.assetId,
        });

        var poleObj = {
          poleId: this.assetId
        };
        this.poleService.reviewPole(poleObj).subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.toastr.success('Successfully reviewed the pole.');
              this.closeModal.emit(responseData.data);
              this.handleReturn();
            } else {
              this.toastr.warning(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured.');
          },
        });
        break;
      }
      case 'Dt': {
        this.analyticsService.logCustomEvent('DT DETAILS: Review', {
          dt_id: this.assetId,
        });

        var dtObj = {
          dtId: this.assetId
        };
        this.dtService.reviewDt(dtObj).subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.toastr.success('Successfully reviewed dt.');
              this.closeModal.emit(responseData.data);
              this.handleReturn();
            } else {
              this.toastr.warning(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured.');
          },
        });
        break;
      }
      
      default: {
        break;
      }
    }
  }

  cancel(event: Event) {
    this.closeModal.emit(null);
  }

  handleReturn() {
    var previous = localStorage.getItem('cameFrom');
    if (!previous) {
      setTimeout(() => {
        window.location.reload();
      }, 500);
      return;
    }

    if (previous == 'Customer') {
      this.router.navigate(['/customers']);
    } else if (previous == 'Building') {
      this.router.navigate(['/buildings']);
    } else if (previous == 'Pole') {
      this.router.navigate(['/poles']);
    } else if (previous == 'Dt') {
      this.router.navigate(['/transformers']);
    }
  }
}
